import React, { forwardRef } from 'react'
import { CircularProgress, styled } from '@mui/material'

export const Root = styled(
  forwardRef(({ color, ...props }, ref) => <CircularProgress {...props} color="primary" ref={ref} />)
)`
  &.MuiCircularProgress-colorPrimary {
    color: ${({ color, theme }) => (color === 'white' ? theme.palette.brand.white : theme.palette.blue[50])};
  }
`
